import React from "react";
import { ProductState } from "../../reducers/productPage/ProductPageReducer";
import { dictionary } from "../../utils/dictionary";
import { DefaultButton } from "../buttons/DefaultButton";
import { useAuth } from "../../context/AuthContext";
import { IconCancelX, IconCircleCheck } from "../../assets/icons/icons";
interface ProductsHeaderProps {
  title: string;
  description: string;
  productsState?: ProductState;
  dispatchProducts?: (action: any) => void;
  onSaveChanges?: () => void;
}

const ProductsHeader: React.FC<ProductsHeaderProps> = ({
  title,
  description,
  productsState,
  dispatchProducts,
  onSaveChanges,
}) => {
  const { language } = useAuth();

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
        {productsState?.hasChanges && (
          <div className="flex justify-end gap-3 p-4">
            <DefaultButton
              title={dictionary["cancel-changes"][language]}
              onClick={() => dispatchProducts?.({ type: "CANCEL_EDITING" })}
              fromColor="#FFFFFF"
              toColor="#FFFFFF"
              fromHoverColor="#F0F0F0"
              toHoverColor="#F0F0F0"
              className="!text-[#5050EA] border border-[#5050EA]"
              icon={<IconCancelX color="#5050EA" width="20px" height="20px" />}
            />
            <DefaultButton
              title={dictionary["save-changes"][language]}
              onClick={() => onSaveChanges?.()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsHeader;
